exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-trigger[data-v-714ba56e]{color:#7b7369!important}.delete-trigger[data-v-714ba56e]:hover{color:#c52a49!important}.confirm-card[data-v-714ba56e]{border-radius:8px!important}.confirm-title[data-v-714ba56e]{color:#17181e;font-weight:800}.confirm-copy[data-v-714ba56e]{color:#5f5a54;font-weight:500;padding-top:18px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-714ba56e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/movies/components/DeleteMovie.vue
// module id = 101
// module chunks = 0